import React from 'react';
import IssueParcelWorkbenchPage from '../../delivery/issueParcelWorkbench/IssueParcelWorkbenchPage';

/**
 * QC 总部「DSP 申诉汇总」页：全美只读视角（mode='HQ'）。
 *
 * 完整复用问题件工作台骨架（筛选栏 / 三 Tab / 列表 / 详情抽屉），
 * 仅在数据范围（全美，无仓库选择器）、鉴权（纯资源码 CS_DSP_APPEAL_SUMMARY）、
 * Tab 文案（待dsp处理 / 申诉审核中 / 已完结）三处按 mode 分叉。
 */
const DspAppealSummaryPage: React.FC = () => {
    return <IssueParcelWorkbenchPage mode="HQ" />;
};

export default DspAppealSummaryPage;
